module.exports = __webpack_public_path__ + "media/images/room_menu_icon/ps_price_schedules-a20f25a43878485e5dc5e94c8a472733.png";